import { getConfigValue } from '@timwoods/bf-config';

export function getAppointmentApiUrl() {
  return getConfigValue('REACT_APP_APPOINTMENT_API_URL');
}
